import React, { Fragment } from 'react'
import { ReceiveLpn } from './ReceiveLpn'
import { AsnSummary } from './AsnSummary'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { AxiosResponse } from 'axios'
import { MoreOptions } from './MoreOptions'
import { AsnSelection } from './AsnSelection'
import { AsnUnkown } from './AsnUnkown'
import { AsnReceiveFilters } from '../Interfaces'
import { stepEnum } from '../enum'

interface NextStepsProps {
  controls: StepperControls
  asnNumber: string
  getAsnSummary: (filters: AsnReceiveFilters) => Promise<AxiosResponse<any>>
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const NextSteps: React.FC<NextStepsProps> = ({
  controls,
  asnNumber,
  getAsnSummary,
  openSnackBar
}) => {
  return (
    <Fragment>
      {controls.currentStep === stepEnum.asnSummary && (
        <AsnSummary
          controls={controls}
          asnNumber={asnNumber}
          getAsnSummary={getAsnSummary}
          openSnackBar={openSnackBar}
        />
      )}
      {controls.currentStep === stepEnum.receiveLpn && (
        <ReceiveLpn controls={controls} openSnackBar={openSnackBar} />
      )}
      {controls.currentStep === stepEnum.moreOptions && (
        <MoreOptions
          controls={controls}
          asnId={controls.currentState as number}
          openSnackBar={openSnackBar}
        />
      )}
      {controls.currentStep === stepEnum.revertReceivedLpn && (
        <ReceiveLpn
          controls={controls}
          openSnackBar={openSnackBar}
          revertReceivedLpn={true}
        />
      )}
      {controls.currentStep === stepEnum.asnSelection && (
        <AsnSelection
          controls={controls}
          getAsnSummary={getAsnSummary}
          openSnackBar={openSnackBar}
        />
      )}
      {controls.currentStep === stepEnum.asnUnkown && (
        <AsnUnkown controls={controls} openSnackBar={openSnackBar} />
      )}
    </Fragment>
  )
}
